import { saveAs } from "file-saver";

class ExcelUtil {
    /**
     * 리스트 데이터를 CSV(Excel 호환) 파일로 다운로드한다.
     *
     * @param {Object} params
     * @param {string} params.fileName - 확장자를 제외한 파일명
     * @param {Array<{key: string, label: string, text?: boolean}>} params.columns
     *        컬럼 정의 (헤더 라벨 + 데이터 키). text:true 이면 Excel 이 날짜/숫자로
     *        자동 변환하지 못하도록 텍스트로 고정한다. (예: "2026-06-16", "2026-04")
     * @param {Array<Object>} params.rows - 내보낼 데이터 목록
     */
    static download({ fileName, columns, rows }) {
        const escapeCell = (value, forceText) => {
            if (value === null || value === undefined) return "";
            const str = String(value);
            // Excel 자동 변환 방지: ="값" 수식으로 감싸 텍스트로 고정
            if (forceText) {
                return `"=""${str.replace(/"/g, '""')}"""`;
            }
            // 따옴표, 쉼표, 줄바꿈이 포함된 경우 따옴표로 감싸고 내부 따옴표는 이스케이프
            if (/["\n\r,]/.test(str)) {
                return `"${str.replace(/"/g, '""')}"`;
            }
            return str;
        };

        const header = columns.map((col) => escapeCell(col.label)).join(",");
        const body = (rows || [])
            .map((row) => columns.map((col) => escapeCell(row[col.key], col.text)).join(","))
            .join("\n");

        // Excel 한글 깨짐 방지를 위한 UTF-8 BOM
        const bom = "﻿";
        const blob = new Blob([bom + header + "\n" + body], { type: "text/csv;charset=utf-8;" });

        saveAs(blob, `${fileName}.csv`);
    }
}

export default ExcelUtil;
